import { Icon, type IconName } from './Icon'
import styles from './QuickAction.module.css'

interface QuickActionProps {
  icon: IconName
  label: string
  meta: string
  onClick: () => void
}

export function QuickAction({ icon, label, meta, onClick }: QuickActionProps) {
  return (
    <button type="button" className={styles.action} onClick={onClick}>
      <span className={styles.icon}>
        <Icon name={icon} size={18} />
      </span>
      <span className={styles.text}>
        <span className={styles.label}>{label}</span>
        <span className={styles.meta}>{meta}</span>
      </span>
      <Icon name="chevron_right" size={18} color="var(--color-text-tertiary)" />
    </button>
  )
}
